module.exports = __webpack_public_path__ + "img/game_icon_1.03bcd7b1.png";